import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
// routes
import { usePathname } from 'src/routes/hooks';
//
import { useAuthContext } from 'src/auth/hooks';
import useBrandName from 'src/hooks/use-brand-name';
import RedirectWithTimer from 'src/components/redirect-with-timer';
import Footer from './footer';
import Header from '../dashboard/header';

// ----------------------------------------------------------------------

export default function MainLayout({ children }) {
  const { user, authenticated } = useAuthContext();
  const { isAgent, isTryVisa, isAgentPurpose } = useBrandName();

  const pathname = usePathname();

  const isHome = pathname === '/' || pathname === '/europe';
  if (isTryVisa && isAgentPurpose && authenticated && user?.purpose) {
    return <RedirectWithTimer redirectType="agent" />;
  }

  if (isAgent && !isAgentPurpose && authenticated && user?.purpose) {
    return <RedirectWithTimer redirectType="tryvisa" />;
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      <Header />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ...(!isHome && {
            pt: { xs: 8, md: 10 },
          }),
        }}
      >
        {children}
      </Box>

      <Footer />
    </Box>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node,
};
